import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/correct.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d6d751b8")

_pushScopeId("data-v-d6d751b8")
const _hoisted_1 = { class: "complete" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "无法显示图片"
  }),
  /*#__PURE__*/_createVNode("div", null, "密码修改成功")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("input", {
  type: "submit",
  value: "登录"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, { to: "login" }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
})